import React from "react"
import ReactMarkdown from "react-markdown"

type MarkdownProps = {
  source: string
  className?: string
}

export const Markdown = ({ source, className }: MarkdownProps) => (
  <div className={`prose-content ${className || ""}`}>
    <ReactMarkdown>{source}</ReactMarkdown>
  </div>
)
